exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".relationFlow-select[data-v-7da79e4a]{width:100%}", ""]);

// exports
